"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = alert;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _InteractionModal = _interopRequireDefault(require("./InteractionModal"));

var _getContainerDOM = _interopRequireDefault(require("./getContainerDOM"));

var _utils = require("./utils");

function alert(message, modalConfig) {
  return new Promise(function (resolve, reject) {
    _reactDom.default.render(_react.default.createElement(_InteractionModal.default, (0, _extends2.default)({
      key: Date.now(),
      showCancelButton: false
    }, modalConfig, {
      onOk: function onOk() {
        if (!(0, _utils.isFunction)(modalConfig === null || modalConfig === void 0 ? void 0 : modalConfig.onOk)) {
          resolve();
          return;
        }

        try {
          var result = modalConfig.onOk();

          if (!(result instanceof Promise)) {
            resolve();
            return;
          }

          result.then(function (resolved) {
            resolve();
            return resolved;
          }, reject);
          return result;
        } catch (e) {
          reject(e);
        }
      }
    }), message), (0, _getContainerDOM.default)());
  });
}